import { PropsWithChildren } from 'react';

import AccountProvider from 'reservations/account/providers/AccountProvider';
import LoadingSpinnerProvider from 'reservations/base/providers/LoadingSpinnerProvider';
import { ModalProvider } from 'reservations/base/providers/ModalProvider';
import QueryProvider from 'reservations/base/providers/QueryProvider';
import { SnackbarProvider } from 'reservations/base/providers/SnackbarProvider';
import MuiThemeProvider from 'reservations/brand/providers/MuiThemeProvider';
import DinerAccountProvider from 'reservations/dinerAccount/providers/DinerAccountProvider';
import PreviewModeProvider from 'reservations/preview/providers/PreviewModeProvider';

const ReservationsProvider = ({ children }: PropsWithChildren) => (
  <LoadingSpinnerProvider>
    <SnackbarProvider>
      <QueryProvider>
        <PreviewModeProvider>
          <AccountProvider>
            <MuiThemeProvider>
              <DinerAccountProvider>
                <ModalProvider>{children}</ModalProvider>
              </DinerAccountProvider>
            </MuiThemeProvider>
          </AccountProvider>
        </PreviewModeProvider>
      </QueryProvider>
    </SnackbarProvider>
  </LoadingSpinnerProvider>
);

export default ReservationsProvider;
